import React, { useRef } from 'react';
import { ServicesTitle, CTAButton } from '../../atoms';
import styles from './ServicesContent.module.css';
import { useLanguage } from '@/contexts/LanguageContext';

interface ServicesContentProps {
  onCtaClick?: () => void;
}

// Gradient markers for different languages
const GRADIENT_MARKERS = {
  en: 'interaction',
  fr: "l'interaction",
} as const;

type SupportedLanguage = keyof typeof GRADIENT_MARKERS;

export const ServicesContent: React.FC<ServicesContentProps> = ({
  onCtaClick,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const titleRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const { t, language } = useLanguage();
  const fullText = t('home.services.text');
  const lang = language as SupportedLanguage;
  const highlight = GRADIENT_MARKERS[lang] ?? GRADIENT_MARKERS.en;
  const parts = fullText.split(highlight);
  const startDescription = parts[0]?.trim() ?? '';
  const endDescription = parts[1]?.trim() ?? '';

  const title = t('home.services.title');
  const ctaText = t('home.services.cta');

  return (
    <div className={styles.servicesContent} ref={containerRef}>
      <div ref={titleRef}>
        <ServicesTitle>{title}</ServicesTitle>
      </div>
      <p ref={contentRef} className={`${styles.manifestoText}`}>
        <span className="everettRegular">{startDescription} </span>
        <span className="gradientTextSpan canelaLight">{highlight} </span>
        <span className="everettRegular">{endDescription}</span>
      </p>

      <div className={styles.ctaContainer}>
        <CTAButton
          ref={buttonRef}
          onClick={onCtaClick}
          className={styles.servicesCta}
          ariaLabel={ctaText}
          data-gtm-label="services-cta"
          data-gtm-location="home-services"
        >
          {ctaText}
        </CTAButton>
      </div>
    </div>
  );
};
